export default class EmailVerificationException extends Error {
  constructor(...args) {
    super(...args);
    this.message = "user's email is not verified.";
  }
}
